import { useState } from 'react';
import getCookie from '../../Queries/getCookie';
//Components
import Button from '@mui/material/Button';
import Preguntas from '../Preguntas';

import LineamientosImage from '../../../images/consultancy/lineamientos.jpg';
import LineamientosImageMobile from '../../../images/consultancy/lineamientos-mobile.jpg';

// Styles
import styles from './index.module.sass';

export default function Lineamientos({
  idCuestionario,
  setSessionMessage,
  screenSize,
  setIsOpenModal,
}) {
  const [mostrarNuevoComponente, setMostrarNuevoComponente] = useState(false);

  function continuar() {
    setMostrarNuevoComponente(true);
  }

  return (
    <>
      {mostrarNuevoComponente ? (
        <Preguntas
          idCuestionario={idCuestionario}
          setSessionMessage={setSessionMessage}
          setIsOpenModal={setIsOpenModal}
          screenSize={screenSize}
        />
      ) : (
        <div>
          <div className={`${styles.header} ${styles[screenSize]}`}>
            ✨ ¡Felicidades {getCookie('kitName')}✨
          </div>
          <div className={`${styles.containerImage} ${styles[screenSize]}`}>
            <img
              src={screenSize === 'phone' ? LineamientosImageMobile : LineamientosImage}
              alt='XVEstrellasLineamientos'
              className={`${styles.imageXV} ${styles[screenSize]}`}
            />
          </div>
          <div className={styles.footer}>
            <Button className={styles.button} variant='contained' onClick={continuar}>
              Comenzar
            </Button>
          </div>
        </div>
      )}
    </>
  );
}
